<template>
  <div>
    <router-view />
    <VLibras style="display: none;" id="main-vlibras" />
  </div>
</template>

<script>
import { VLibras } from '@vue-a11y/vlibras';

export default {
  name: 'App',
  components: { VLibras },
};
</script>
